import { clsx } from 'clsx';
import type { PanelResizeState } from '@/hooks/usePanelResize';

interface PanelResizeHandleProps {
  state: PanelResizeState;
  /**
   * ghost: invisible until hovered — for panels separated by whitespace.
   * separator: always draws the divider line (replaces the panel border).
   */
  variant: 'ghost' | 'separator';
  className?: string;
}

export function PanelResizeHandle({ state, variant, className }: PanelResizeHandleProps) {
  return (
    <div
      {...state.handleProps}
      className={clsx(
        'panel-resize-handle',
        variant === 'separator' && 'panel-resize-handle--separator',
        state.isResizing && 'is-resizing',
        className
      )}
    />
  );
}
